module.exports = __webpack_public_path__ + "img/xas.2e1a5a03.svg";